import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " (europass.europa.eu)", -1)
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  class: "me-3",
  style: {"min-width":"80px"}
}

import LanguageSelect from "./LanguageSelect.vue";

import { useValidateProps } from "@/composables/fields";
import { computed, nextTick, PropType, ref } from "vue";
import { useI18n } from "vue-i18n";
import Field from "./form/Field.vue";
import { LanguageDto } from "@api/language-dto";
import { LanguageSkillDto } from "@api/language-skill-dto";
import { LanguageSkillLevel } from "@db/language-skill-level";
import { dbEnums } from "@/types/enums/dbEnums";
import { getLanguageTranslation } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSkillsField',
  props: {
	modelValue: {
		type: [Array, null] as PropType<LanguageSkillDto[] | null>,
		required: true,
	},
	propertyPath: {
		type: String,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n();

const props = __props;

const refTempLang = ref(null as LanguageDto | null);

const cValue = computed({
	get() {
		return props.modelValue;
	},
	set(newValue: LanguageSkillDto[] | null) {
		emit("update:modelValue", newValue);
	},
});

const cSkillLevels = computed(() => {
	const levels = [] as string[];

	const enumLevels = Object.keys(dbEnums.LanguageSkillLevel).filter((v) => isNaN(Number(v)));

	enumLevels.forEach((r) => levels.push(r));

	return levels;
});

const fnTransformName = (name: string) => {
	if (name == "Native") return t("generic.nativeLanguageSkill");
	if (name == "Other") return "-";
	return name;
};

const validateProps = useValidateProps();

const addLanguageSkill = (lang: LanguageDto) => {
	if (lang === null) return;
	if (!cValue.value) cValue.value = [] as LanguageSkillDto[];

	cValue.value.push({
		id: 0,
		languageCode: lang.code,
		language: lang,
		skillLevel: "Other" as unknown as LanguageSkillLevel,
		personImmigrantDataId: null,
	} as LanguageSkillDto);

	nextTick(() => {
		refTempLang.value = null;
	});
};

const removeLanguageSkill = (index: number) => {
	if (cValue.value) {
		cValue.value.splice(index, 1);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_HakoRadio = _resolveComponent("HakoRadio")!
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", null, [
        _createElementVNode("a", {
          href: 
						'https://europass.europa.eu/system/files/2020-05/CEFR%20self-assessment%20grid%20' +
						_ctx.$i18n.locale.toUpperCase() +
						'.pdf'
					,
          target: "_blank"
        }, _toDisplayString(_ctx.$t("generic.showLanguageSkillDescription")), 9, _hoisted_2),
        _hoisted_3
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cValue.value, (skill, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card px-3 py-2 mb-2",
        key: i
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Field, {
            propertyPath: `${__props.propertyPath}[${i}].skillLevel`,
            label: _ctx.$t('generic.skillLevel'),
            noLabel: ""
          }, {
            default: _withCtx(({ propertyPaths }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(getLanguageTranslation)(skill.language) || skill.languageCode), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cSkillLevels.value, (level) => {
                  return (_openBlock(), _createBlock(_component_HakoRadio, {
                    key: level,
                    modelValue: skill.skillLevel,
                    "onUpdate:modelValue": [($event: any) => ((skill.skillLevel) = $event), ($event: any) => (_unref(validateProps)(propertyPaths))],
                    inline: "",
                    value: level
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(fnTransformName(level)), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["propertyPath", "label"]),
          _createVNode(_component_HakoBsIcon, {
            style: {"cursor":"pointer"},
            class: "text-danger",
            icon: "trash-fill",
            onClick: () => removeLanguageSkill(i)
          }, null, 8, ["onClick"])
        ])
      ]))
    }), 128)),
    _createVNode(LanguageSelect, {
      valueSingle: refTempLang.value,
      "onUpdate:valueSingle": [
        _cache[0] || (_cache[0] = ($event: any) => ((refTempLang).value = $event)),
        addLanguageSkill
      ],
      ajax: "",
      isInvalid: undefined,
      placeholder: _ctx.$t('generic.searchLanguage')
    }, {
      default: _withCtx(({ openMenu }) => [
        _createVNode(_component_HakoButton, {
          onClick: openMenu,
          theme: "success",
          uncapitalize: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("generic.addLanguageSkill")), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["valueSingle", "placeholder"])
  ]))
}
}

})